#import "~/graphql/fragments/Entry/ProjectHero.graphql"
#import "~/graphql/fragments/Entry/DefaultHero.graphql"
#import "~/graphql/fragments/Entry/Cards/DefaultCard.graphql"
#import "~/graphql/fragments/Entry/Cards/DetailCard.graphql"

query RelatedContent(
    $site: [String] = "nl"
    $section: [String]
    $relatedTo: [QueryArgument]
    $notRelatedTo: [QueryArgument]
    $offset: Int = 0
    $limit: Int = 3
    $isNotPast: [QueryArgument]
    $isBetween: [QueryArgument]
    $orderBy: String
    $ids: [QueryArgument]
) {
    entries(
        site: $site,
        section: $section,
        relatedTo: $relatedTo
        notRelatedTo: $notRelatedTo
        offset: $offset
        limit: $limit
        isNotPast: $isNotPast
        isBetween: $isBetween
        orderBy: $orderBy
        id: $ids
    ) {
        id
        slug
        uri
        __typename
        sectionHandle

        ... on default_Entry {
            ... DefaultCard

            neighbourhoodRelation {
                ... on category_Entry {
                    title
                    slug
                }
            }
        }

        ... on detail_Entry {
            ... DetailCard

            neighbourhoodRelation {
                ... on category_Entry {
                    title
                    slug
                }
            }

            dateRange {
                start
                end
            }
        }

    }

    entryCount(
        site: $site,
        section: $section,
        relatedTo: $relatedTo
        isNotPast: $isNotPast
        isBetween: $isBetween
    )
}
